import axios from 'axios'
import Credentials from './Credentials'
import CurrentUser from './CurrentUser'

const HOSTS = {
  localhost: 'http://localhost:3000',
  development: 'https://development.moqo.de',
  prerelease: 'https://prerelease.moqo.de'
}

export default class {

  constructor(environment) {
    this.environment = environment
  }

  verifyApiToken(apiToken, callback) {
    let environment = this.environment
    axios.get(`${this.host}/api/account`, {
      headers: {
        'Authorization': apiToken
      },
      mode: 'no-cors'
    }).then((response)=>{
      Credentials.set(environment, apiToken)
      CurrentUser.set(environment, response.data)
      callback(true)
    }).catch(()=>{
      callback(false)
    })
  }

  storeEnvironmentAsDefault() {
    window.localStorage.setItem('default-env', this.environment)
  }

  static get defaultEnvironment() {
    return window.localStorage.getItem('default-env')
  }

  static get defaultHost() {
    return HOSTS[this.defaultEnvironment]
  }

  get host() {
    return HOSTS[this.environment]
  }

  static get hosts() {
    return HOSTS
  }
}

